export default {
  SPECIAL: "特殊學習需要",
  READING: "閱讀",
  PARENT_SCH_COOP: "家校協作",
  WIFI: "無線網絡設定及帳戶管理",
  STEM: "科學、技術、工程及數學",
  ASSESSMENT: "促進學習的評估",
  RESOURCE: "教學法及教學資源",
  SELF_LEARNING: "自主學習及獎勵計劃",
  E_LEARNING: "電子學習趨勢及創新學習",
  PROFESSIONAL: "專業發展",
};
